<template>
	<div class="col-md-12 p-l-r-0 f-left">
		<div class="col-md-12 p-l-r-0 f-left">
			<div class="form-group col-md-6 p-l-r-0 f-left">
				<label for="Website">Website (if available)</label>
    			<input type="text" v-model="propdata.website" class="form-control" id="Website" >
				<span class="text-danger" v-if="validation_errors.website">Please enter website address</span>
            </div>
		</div>
		<div class="col-md-12 p-l-r-0 f-left">
			<div class="form-group col-md-12 p-l-r-0 p-r-0 nospace f-left">
				<label for="Website">    Please add a brief note about your business objective.*</label>
    			<textarea class="form-control text-area" id="Website" v-model="propdata.brief_note"  rows="4" ></textarea>
				<span class="text-danger" v-if="validation_errors.brief_note">Please enter Brief note  of business</span>
            </div>
		</div>
		<div class="col-md-12 p-l-r-0 f-left nospace form-group" >
			<label class="full_width-label" v-if="parentName =='pvtopcName'" >Proposed Company Name*</label>
			<label class="full_width-label" v-if="parentName !='pvtopcName'">OPC Name*</label>
			<div class=" col-md-6 p-l-r-0 f-left">
				
    			<input type="text" class="form-control" id="Option2" placeholder="Option 1" v-model="propdata.proposed_company_name_option1">
            </div>
            <div class="col-md-6 p-r-0 f-left" style="padding-right: 0px;">
    			<input type="text" class="form-control" id="Option1" placeholder="Option 2" v-model="propdata.proposed_company_name_option2">
            </div>
			<span class="text-danger" v-if="validation_errors.proposed_company_name_option1">Please enter proposed company name</span>
            <div class=" col-md-12 p-l-r-0 p-r-0 f-left">
	            <span v-if="parentName =='pvtopcName'" class="teptext">Please ensure the proposed name is unique and contains the company objective; for e.g., a marketing company should be named ABC Marketing Private Limited. Your company name is subject to approval. </span>

	            <span v-if="parentName !='pvtopcName'" class="teptext">    Please ensure the proposed name is unique and contains the company objective; for e.g., a marketing company should be named ABC Marketing OPC. Your company name is subject to approval. </span>
	        </div>
		</div>



		<div class="col-md-12 p-l-r-0 f-left">
			<div class="form-group col-md-6 p-l-r-0 f-left">
				<label for="aCapital">Authorised Capital*</label>
    			<input type="text" class="form-control" id="aCapital" placeholder="1000000" v-model="propdata.authorized_capital">
    			<span class="teptext">    An extra fee will be added for authorised capitals beyond 1000000. </span>
				<span class="text-danger" v-if="validation_errors.authorized_capital">Please enter  authorized capital value</span>
            </div>
            <div class="form-group col-md-6 p-r-0 f-left">
				<label for="pCapital">    Paid Up Capital* </label>
    			<input type="text" class="form-control" id="pCapital" v-model="propdata.paid_up_capital" >
    			<span class="teptext">    Please note that your Paid-up capital cannot be more than the Authorized Capital (generally 1 Lakh). And the entered amount will have to be deposited in accordance to the ownership ration by the directors on completion of the incorporation process and opening of the company bank account.  </span>
				<span class="text-danger" v-if="validation_errors.paid_up_capital">Please enter  paid up capital value</span>
            </div>
		</div>
		<div class="col-md-12 p-l-r-0 f-left">
			<div class="form-group col-md-6 p-l-r-0 f-left">
				<label for="rCompany" v-if="parentName =='pvtopcName'">Registered office address of proposed company*</label>
				<label for="rCompany" v-if="parentName !='pvtopcName'">Registered office address of OPC*</label>

    			<input type="text" class="form-control" id="rCompany" v-model="propdata.registered_office" >
    			<span class="teptext">    In case you do not have a confirmed registered office address, please provide an address in the state in which you wish to have your registered office for now.  </span>
				<span class="text-danger" v-if="validation_errors.registered_office">Please enter  registered office address</span>
            </div>
		</div>
		<!-- <div class="col-md-12 p-l-r-0 f-left other_details_fileupload">
			<div  class="form-group col-md-6 p-l-r-0 f-left choosefile-upload">
				<div v-for="(docs,index) in other_documents" :key="index">
					<label class="lable-full-width">Upload Documents</label>
					<input type="file" id="Documents" hidden @change="getDocuments"/>
					<label class="choose-btn" for="Documents">Choose file</label>
					<span id="file-chosen">{{Documents}}</span>
				</div>
			</div>
			<div class="pluse-icon">
					<a href="javascript://" @click="AddDocuments()"><img src="../assets/pluse-icon.png"></a>
			</div>
		</div> -->
		<div class="col-md-12 p-l-r-0 f-left "><br>
			<button type="button" class="btn btn-primary gobtn submit" @click="Submit()">Submit</button>
		</div>
	</div>
</template>
<script>



import company_info from "../services/company_info"
export default {
    name:'other_details',
    props: ["parentName","propdata",],
     watch:{
       propdata: function (data){
		   this.other_documents=data
	   }
	   
    },
    data() {
        return {
        	Documents: "",
			other_documents:[],
			validation_errors:{}
        }
    },
    methods: {
    	getDocuments(e){
			this.Documents = e.target.files[0].name;
		},
		AddDocuments(){
			// alert('gfwef')
			// this.other_documents.push({document_url:''})
		},
		Submit(){
			this.validation_errors={}
			company_info.postOtherDetails(this.propdata)
						.then(response=>{
							if(response.data.status=='success'){
								this.$notify({
                                group: 'auth',
                                title:'',
                                type: 'success',
                                text: 'Details saved successfully',
								ignoreDuplicates:true
                            });
							}
							 this.$emit("other_update", {
								src: this.parentName
							});
						})
						.catch(error=>{
							// console.log(error.response)
						if(error.response.status==422){
							this.$notify({
									group: 'auth',
									title:'',
									type: 'warn',
									text: 'Please fill all required fields',
									ignoreDuplicates:true
								});
								var err=error.response.data.status;
								var temp={};
								Object.keys(err).forEach((key) => {
									temp[key]=err[key][0]
								});
								this.validation_errors=temp
							}
					})
		}
    }
};

</script>
